import React, { useState } from 'react';
import { FaFilter, FaTimes } from 'react-icons/fa';
import { useTranslation } from "react-i18next";
import { FaCheck } from 'react-icons/fa6';

const FilterComponent = ({ columnHeaders, fieldsToShow, optionArrays, onFilterChange, onResetFilters, showFilterOptions, toggleShowFilter }) => {
  const [selectedOptions, setSelectedOptions] = useState({});
  const [t] = useTranslation("filters")
  const stopPropagation = (event) => {
    event.stopPropagation();
  };


  const handleOptionChange = (e, value) => {
    setSelectedOptions({
      ...selectedOptions,
      [value]: e.target.value,
    });
  };

  const applyFilters = () => {
    onFilterChange(selectedOptions);
    toggleShowFilter();
  };

  const resetFilters = () => {
    setSelectedOptions({});
    onResetFilters();
    toggleShowFilter();
  };

  // Generar el array de objetos filterOptions y filtrar aquellos con un array vacío
  const filterOptions = columnHeaders.map((header, index) => ({
    label: header,
    property: fieldsToShow[index],
    options: optionArrays[index]?.map(value => ({ label: value, value })),
  })).filter(option => option.options && option.options.length > 0);





  return (
    <div>
      <FaFilter style={{ cursor: 'pointer' }} />

      {showFilterOptions && (
        <div
          onClick={stopPropagation}
          className='filter-chart-container custom-shadow'
        >
          <h5 className='dark-gray-color'>{t("filters.title")}</h5>
          <div className='filters-container'>
            {filterOptions.map((filter, index) => (
              <div key={index} style={{ marginBottom: '10px' }}>
                <label style={{ color: '#555555', textAlign: 'left' }}>{filter.label}</label>
                <select
                  style={{
                    display: 'block',
                    width: '100%',
                    padding: '6px',
                    border: '1px solid #d9d9d9',
                    borderRadius: '4px',
                    color: '#555555',
                  }}
                  onChange={(e) => handleOptionChange(e, filter.property)}
                  value={selectedOptions[filter.property] || ''}
                >
                  <option value="">{t("filters.select")}</option>
                  {filter.options?.map((option, idx) => (
                    <option key={idx} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </select>
              </div>
            ))}
          </div>
          <div className='filter-chart-button-container mt-2'>
            <button
              onClick={resetFilters}
              className='p-2 custom-button-secondary'
              style={{
                marginRight: '10px',
                background: '#818181',
                color: '#f5f5f5',
                padding: '8px 16px',
                borderRadius: '4px',
                border: 'none',
              }}
            >
              <FaTimes /> {t("filters.clear")}
            </button>
            <button
              onClick={applyFilters}
              className='p-2 custom-button-primary'
              style={{
                background: '#555555',
                color: '#f5f5f5',
                padding: '8px 16px',
                borderRadius: '4px',
                border: 'none',
              }}
            >
              <FaCheck /> {t("filters.apply")}
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default FilterComponent;
